import styled from 'styled-components'

import { BORDER_RADIUS, CommonColorPalette, MEDIA_QUERY } from '../../../../styles'
import { Button } from '../Button'
import { ButtonMinWidth } from '../types'
import { ButtonSelectTheme } from './types'


export const Container = styled.div<{ $buttonWidth?: ButtonMinWidth }>`
  display: inline-block;
  position: relative;
  min-width: ${({ $buttonWidth }) => $buttonWidth};
  @media ${MEDIA_QUERY.MOBILE} {
    width: 100%;
  }
`

export const MainButton = styled(Button)<{ $buttonWidth?: ButtonMinWidth }>`
  min-width: ${({ $buttonWidth }) => $buttonWidth};
  display: grid;
  grid-template-columns: 1fr 15px;
  align-items: center;
  justify-content: center;
  gap: 5px;
  padding: 0 10px 0 15px;
`

export const Items = styled.div`
  position: absolute;
  z-index: 99;
  width: 100%;
`

const themeColorMap: Record<Exclude<ButtonSelectTheme, 'transparent'>, CommonColorPalette> = {
  orange: 'orange',
  blue: 'brightBlue'
}

export const ItemsInner = styled.ul<{ $itemsTheme: ButtonSelectTheme }>`
  width: 100%;
  position: relative;
  border-top: none;
  background-color: ${({ theme }) => theme.colors.background.white};
  top: 10px;
  padding: 0;
  border-radius: ${BORDER_RADIUS};
  border-radius: ${BORDER_RADIUS};
  box-shadow: 0 1px 1px rgba(11, 31, 66, 0.04), 0 2px 8px rgba(11, 31, 66, 0.1);

  li:first-child > a {
    border-top-right-radius: ${BORDER_RADIUS};
    border-top-left-radius: ${BORDER_RADIUS};
  }

  li:last-child > a {
    border-bottom-right-radius: ${BORDER_RADIUS};
    border-bottom-left-radius: ${BORDER_RADIUS};
  }

  li > a {
    color: ${({ theme, $itemsTheme }) =>
      $itemsTheme === 'transparent'
        ? theme.colors.common.regular.brightBlue
        : theme.colors.common.regular[themeColorMap[$itemsTheme]]};

    &:hover {
      background-color: ${({ theme, $itemsTheme }) =>
        $itemsTheme === 'transparent'
          ? theme.colors.background.greyMid
          : theme.colors.common.extraLight[themeColorMap[$itemsTheme]]};
    }
  }
`

export const Item = styled.a`
  width: 100%;
  padding: 8px;
  position: relative;
  display: flex;
  align-items: center;
  gap: 10px;
`
